import fetch from '@/api/fetch'

/** 查询最顶层字典项 */
export const getTopItems = () => fetch.get('/item/top/items');

/** 根据typeCode查询下级 */
export const getItemByTypeCode = typeCode => fetch.get(`/item/typeCode/${typeCode}`);

/** 新增或修改 */
export const saveOrUpdateItem = item => fetch.post('/item/save', item);

/** 根据id单条删除 */
export const deleteItemById = id => fetch.delete(`/item/delete/id/${id}`)

/** 紧急联系人关系查询 */
export const getRalationShipItems = () => fetch.get('/join/typeCode/ralationship');